import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

// ── NavDropdown ───────────────────────────────────────────────────────────────
// Header dropdown for grouped nav items (e.g. Settings → Assessments/Reports/Pipeline,
// or Stewardship → Stewardship Plan/Species Catalog).
const NavDropdown = ({ label, items }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  useEffect(() => { setOpen(false); }, [location.pathname, location.search]);

  const isActive = items.some(({ to }) => location.pathname.startsWith(to));

  return (
    <div ref={ref} className="navbar-dropdown" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className={`navbar-dropdown__toggle${isActive ? ' navbar-link--active' : ''}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {label} <span className="navbar-dropdown__caret">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div className="navbar-dropdown__menu">
          {items.map(({ to, label: itemLabel }) => (
            <NavLink key={to} to={to} className={({ isActive: a }) => a ? 'navbar-link--active' : undefined}>
              {itemLabel}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default NavDropdown;
